var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65336 1.43986C10.3365 -0.202727 12.6635 -0.202727 13.3466 1.43986L14.8662 5.09324C15.1542 5.78571 15.8054 6.25885 16.553 6.31879L20.4971 6.63498C22.2704 6.77715 22.9895 8.99017 21.6384 10.1475L18.6334 12.7216C18.0638 13.2095 17.8151 13.9751 17.9891 14.7046L18.9072 18.5534C19.3199 20.2838 17.4374 21.6516 15.9192 20.7243L12.5425 18.6618C11.9025 18.2708 11.0975 18.2708 10.4575 18.6618L7.08076 20.7243C5.56256 21.6516 3.68006 20.2838 4.09283 18.5534L5.01091 14.7046C5.18493 13.9751 4.93619 13.2095 4.36661 12.7216L1.36159 10.1475C0.0105183 8.99017 0.729571 6.77715 2.50288 6.63498L6.44702 6.31879C7.1946 6.25885 7.84582 5.78571 8.13383 5.09324L9.65336 1.43986Z",
    fill: "#1BD0DC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.454f4fef.svg";
export { ForwardRef as ReactComponent };